import React, { useEffect } from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { Form, useFormikContext, withFormik } from 'formik';
import { ErrorList } from '../components/ErrorList';
import { InputBox } from '../components';
import { useHistory } from 'react-router-dom';

const formikWrapper = withFormik({
  validateOnMount: false,
  validateOnBlur: false,
  validateOnChange: false,
  mapPropsToValues: (props) => ({
    ...props.initialValues,
  }),
  handleSubmit: (values, formikBag) => {
    values.matomo.trackEvent({
      category: 'Transaction Payment Service ID',
      action: 'Completed',
    });
    delete values.matomo;
    let next = 'bank-details';
    if (values.editMode) {
      next = 'review-answers';
    }
    values.sections.add('payment-service-id');
    formikBag.props.updateValues(values, next);
  },
});

const PaymentServiceId = ({ values, setFieldValue }) => {
  const formik = useFormikContext();
  const { trackPageView, trackEvent } = useMatomo();
  const history = useHistory();
  values.matomo = { trackEvent };

  useEffect(() => {
    trackPageView({
      documentTitle: 'Payment service ID - Report Suspicious Chemical Activity'
    });
    trackEvent({
      category: 'Transaction Payment Service ID',
      action: 'Started',
    });
  }, []);

  return (
    <div>
      <a
        className="govuk-back-link"
        href="#"
        onClick={() => {
          if (!values.editMode) {
            setFieldValue(
              `sections`,
              values.sections.delete(`payment-service-id`)
            );
          }
          history.goBack();
        }}
      >
        Back
      </a>
      <main
        className="govuk-main-wrapper govuk-main-wrapper--auto-spacing"
        id="content"
        role="main"
        tabIndex={0}
      >
        <div className="govuk-grid-row">
          <div className="govuk-grid-column-two-thirds">
            <ErrorList />
            <span className="govuk-caption-l">Transaction details</span>
            <Form onSubmit={formik.handleSubmit}>
              <div className="govuk-grid-column">
                <InputBox
                  name="transaction.payment_service_id"
                  subText="Their PayPal ID. The investigators will only use this as part of their investigation."
                  size="20"
                  hintId="payment-id-hint"
                  questionLarge="Payment service ID"
                />
              </div>
              <button
                type="submit"
                data-prevent-double-click="true"
                className="govuk-button"
                data-module="govuk-button"
                data-test={`button-continue`}
                aria-label={'Continue'}
              >
                Continue
              </button>
            </Form>
          </div>
        </div>
      </main>
    </div>
  );
};

const PaymentServiceIdWithFormik = formikWrapper(PaymentServiceId);

export { PaymentServiceIdWithFormik as PaymentServiceId };
